import { MethodInstall } from "../../utils";
import Download from "./src/index.js";

export default MethodInstall(Download, "Download");
